export const reviews = {
  "reviews/main": {
    shape:
      '<path fill="#006ADB" d="m17.35 19.3-2.825-2.85.7-.7 2.125 2.125 4.25-4.25.7.725-4.95 4.95ZM5.65 16h6.85v1H6.075L3 20.075V4.625c0-.467.154-.854.463-1.163C3.771 3.154 4.158 3 4.625 3h14.75c.467 0 .854.154 1.163.462.308.309.462.696.462 1.163V11.5h-1V4.625a.609.609 0 0 0-.175-.45.61.61 0 0 0-.45-.175H4.625a.61.61 0 0 0-.45.175.61.61 0 0 0-.175.45V17.65L5.65 16Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
